import React from 'react';
import { useUiLang } from '../utils/lang.js';

export const Header = ({ title, showBack = false, children = null, backDisabled = false, onBack = null, showSettings = true, hideOnScroll = true, onOpenSettings = null, showSearch = true, onOpenSearch = null }) => {
  const ref = React.useRef(null);
  const [hidden, setHidden] = React.useState(false);
  const lastYRef = React.useRef(0);
  const uiLang = useUiLang();
  const isAr = uiLang === 'ar';

  const goBack = () => {
    if (backDisabled) return;
    if (typeof onBack === 'function') { onBack(); return; }
    if (window.history.length > 1) window.history.back();
  };

  React.useLayoutEffect(()=>{
    const updateVars = ()=>{
      const h = ref.current ? ref.current.offsetHeight : 44;
      const val = `${h}px`;
      document.documentElement.style.setProperty('--header-offset', val);
    };
    updateVars();
    const onResize = ()=> updateVars();
    window.addEventListener('resize', onResize);
    const t = setTimeout(updateVars, 50);
    return ()=>{ window.removeEventListener('resize', onResize); clearTimeout(t); };
  },[hidden]);

  React.useEffect(()=>{
    if (!hideOnScroll) return;
    
    const scrollContainer = document.getElementById('root');
    if (!scrollContainer) return;
    
    const onScroll = () => {
      const y = scrollContainer.scrollTop || 0;
      const last = lastYRef.current;
      if (y > last + 10 && y > 40) setHidden(true);
      else if (y < last - 10) setHidden(false);
      lastYRef.current = y;
    };
    scrollContainer.addEventListener('scroll', onScroll, { passive: true });
    return () => scrollContainer.removeEventListener('scroll', onScroll);
  },[hideOnScroll]);

  const Actions = (
    (showSearch || showSettings) ? (
      <div className="header__actions" style={{display:'flex', alignItems:'center', gap:8}}>
        {showSearch && (
          <button className="settings-btn" aria-label="Поиск" onClick={onOpenSearch}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </button>
        )}
        {showSettings && (
          <button className="settings-btn" aria-label="Настройки" onClick={onOpenSettings}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          </button>
        )}
      </div>
    ) : null
  );

  return (
    <header ref={ref} className={`header ${hidden ? 'header--hidden' : ''}`}>
      <div className="header__top">
        {isAr && (
          <>
            {Actions}
            <div style={{width: 12}} />
          </>
        )}
        {!isAr && showBack && (
          <button className="back-btn" onClick={backDisabled ? undefined : goBack} aria-label="Назад" aria-disabled={backDisabled}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
        )}
        {!isAr && <div className="header__brand">MubarakWayKoran</div>}
        {children ? (
          <div style={{flex: 1}}>{children}</div>
        ) : (
          title && <div className="header__title">{title}</div>
        )}
        {isAr && (
          <div className="header__brandbar" style={{display:'flex', flexDirection:'row', alignItems:'center', gap:8, marginLeft:'auto'}}>
            <div className="header__brand">MubarakWayKoran</div>
            {showBack && (
              <button className="back-btn" onClick={backDisabled ? undefined : goBack} aria-label="Назад" aria-disabled={backDisabled}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
              </button>
            )}
          </div>
        )}
        {!isAr && (
          <div style={{marginLeft:'auto'}}>{Actions}</div>
        )}
      </div>
      <div id="subheader-slot" className="header__bottom-slot" />
    </header>
  );
};
